import { lazy, Suspense, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import Loader from '../../../components/Loader';
import { useOptions } from '../../../hooks';
import { loadPoll } from '../../../models/polls';
import { getPollStatuses } from '../../../resources/pollStatuses';
import { useAppDispatch, useAppSelector } from '../../../store';

import * as style from '../style.module.scss';

const LandingPage = lazy(() => import('../LandingPage'));
const CarouselPage = lazy(() => import('../CarouselPage'));
const ThanksForVotingPage = lazy(() => import('../ThanksForVotingPage'));
const PollClosedPage = lazy(() => import('../PollClosedPage'));
const WinnerPage = lazy(() => import('../WinnerPage'));
const OpeningSoonPage = lazy(() => import('../OpeningSoonPage'));
const GoodChoicePage = lazy(() => import('../GoodChoicePage'));

const MainGOTS = () => {
  const params: { pollId?: string } = useParams();
  const directLink = !!params?.pollId;
  const currentPoll = useAppSelector((state) => state.polls.currentPoll);
  const isLoading = useAppSelector((state) => state.polls.isLoading);
  const pageStatus = useAppSelector((state) => state.user?.pageStatus);
  const dispatch = useAppDispatch();
  const { cup, seasonYear, pollType, pollSubtype, appType } = useOptions();

  useEffect(() => {
    dispatch(
      loadPoll({
        cup,
        seasonYear,
        pollType,
        pollSubtype,
        appType,
        pollId: params?.pollId,
      }),
    );
  }, [appType, cup, dispatch, params?.pollId, pollSubtype, pollType, seasonYear]);

  const { pollIsWinner, pollIsClosed, pollIsOpen } = useMemo(() => getPollStatuses(currentPoll), [currentPoll]);

  const directLinkPageManagement = () => {
    if (directLink) {
      return <CarouselPage poll={currentPoll} />;
    } else {
      return <LandingPage poll={currentPoll} />;
    }
  };

  const pollOpenPageManagement = () => {
    if (pageStatus === 'VOTED') {
      return <CarouselPage poll={currentPoll} alreadyVoted />;
    } else if (pageStatus === 'VOTING_COMPLETE') {
      return <ThanksForVotingPage poll={currentPoll} />;
    } else if (pageStatus === 'ENTER_PRIZE_DRAW') {
      return <GoodChoicePage />;
    } else {
      return directLinkPageManagement();
    }
  };

  const content = () => {
    if (pollIsWinner) {
      return <WinnerPage poll={currentPoll} />;
    } else if (pollIsClosed) {
      return <PollClosedPage poll={currentPoll} />;
    } else if (pollIsOpen) {
      return pollOpenPageManagement();
    } else {
      return <OpeningSoonPage />;
    }
  };
  return (
    <div className={style.gotsSkeleton}>
      {isLoading ? <Loader /> : <Suspense fallback={<Loader />}>{content()}</Suspense>}
    </div>
  );
};

export default MainGOTS;
